import { ClockIcon } from '@heroicons/react/24/outline'

interface Props {
  time: number
  className?: string
}

const Time: React.FC<Props> = ({ time, className }) => (
  <span className={` flex items-center text-xs ${className}`}>
    <ClockIcon width={12} className='mr-2 mb-1' />
    {`${time} min`}
  </span>
)

export default Time
